import { Autocomplete, Box, Button, Card, Fade, Grid, Modal } from "@mui/material";
import { makeStyles } from "@mui/styles";
import fetchCompanyJob from "api/companies/fetchCompanyJob";
import fetchCustomers from "api/companies/fetchCustomers";
import MDTypography from "components/MDTypography";
import { useAppContextController } from "context/AppContext";
import FormField from "layouts/applications/wizard/components/FormField";
import { useSnackbar } from "notistack";
import { useMemo, useState } from "react";
import { useQuery } from "react-query";

const useStyle = makeStyles({
  container: {
    position: "absolute",
    width: "25%",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "2rem",
    overflow: "hidden",
  },
  wideContainer: {
    width: "50%",
  },
  dropzone: {
    height: 170,
  },
  editor: {
    height: 150,
  },
});

const SelectJobForInterviewModal = ({ open, handleClose, onSelectJob }) => {
  const { currentLoggedUser } = useAppContextController();
  const { enqueueSnackbar } = useSnackbar();
  const [selectedJob, setSelectedJob] = useState("");
  const [selectedCustomerFilter, setSelectedCustomerFilter] = useState("");
  const [selectedCompany, setSelectedCompany] = useState("");
  const classes = useStyle();

  const options = { fetchAll: true };
  const allOptions = { ...options, filters: { primaryCompany: false } };
  const allOptionsJobs = {
    ...options,
    filters: {
      ...(selectedCustomerFilter ? { companySlug: selectedCustomerFilter.slug } : {}),
    },
  };

  const {
    data: companies,
    isLoading,
    isSuccess,
  } = useQuery(["companies", allOptions], () => fetchCustomers(allOptions));

  const {
    data: jobs,
    isLoading: isLoadingJobs,
    refetch,
  } = useQuery(["availableJobs", allOptionsJobs], () => fetchCompanyJob(allOptionsJobs));

  const customerNames = useMemo(() => {
    if (companies?.data) {
      return companies?.data?.map((comp) => ({
        ...comp,
        label: `${comp.name}`,
      }));
    }
    return [];
  }, [companies?.data]);

  const jobNames = useMemo(() => {
    if (jobs?.data) {
      return jobs?.data?.map((job) => ({
        ...job,
        label: `${job.title} - ${job.companyName}`,
      }));
    }
    return [];
  }, [jobs?.data]);

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Fade in={open}>
          <Card className={classes.container}>
            <Box>
              <MDTypography variant="h5" color="dark">
                Select job
              </MDTypography>
              <Grid container>
                <Grid container item xs={12}>
                  <Autocomplete
                    options={customerNames || []}
                    freeSolo
                    defaultValue=""
                    loading={isLoading}
                    value={selectedCustomerFilter?.name || ""}
                    onChange={(e, v) => {
                      setSelectedCustomerFilter(v);
                    }}
                    renderOption={(props, option, index) => {
                      const key = `listItem-${index}-${option._id}`;
                      return (
                        <li {...props} key={key}>
                          {option.label}
                        </li>
                      );
                    }}
                    sx={{
                      width: "100%",
                      marginTop: 2,
                    }}
                    renderInput={(params) => (
                      <FormField {...params} type="text" label="Filter by Customer" fullWidth />
                    )}
                  />
                </Grid>
                <Grid container item xs={12}>
                  <Autocomplete
                    options={jobNames || []}
                    freeSolo
                    defaultValue=""
                    loading={isLoadingJobs}
                    value={selectedJob?.title || ""}
                    onChange={(e, v) => {
                      setSelectedJob(v);
                      if (v) {
                        const currentCompany = companies.data?.find(
                          (comp) => comp.slug === v.companySlug
                        );
                        if (currentCompany) setSelectedCompany(currentCompany);
                      }
                    }}
                    renderOption={(props, option, index) => {
                      const key = `listItem-${index}-${option._id}`;
                      return (
                        <li {...props} key={key}>
                          {option.label}
                        </li>
                      );
                    }}
                    sx={{
                      width: "100%",
                      marginTop: 2,
                    }}
                    renderInput={(params) => (
                      <FormField {...params} type="text" label="Job Name" fullWidth />
                    )}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3} justifyContent="flex-end" mt={1}>
                <Grid item sm={3}>
                  <Button
                    color="error"
                    variant="contained"
                    fullWidth
                    onClick={(e) => {
                      e?.stopPropagation();
                      handleClose();
                    }}
                  >
                    <MDTypography variant="body2" color="white">
                      Cancel
                    </MDTypography>
                  </Button>
                </Grid>
                <Grid item sm={3}>
                  <Button
                    variant="contained"
                    fullWidth
                    disabled={!selectedJob}
                    onClick={async (e) => {
                      e?.stopPropagation();
                      onSelectJob?.({ job: selectedJob, company: selectedCompany });
                      handleClose();
                    }}
                  >
                    <MDTypography variant="body2" color="white">
                      Continue
                    </MDTypography>
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Card>
        </Fade>
      </Modal>
    </>
  );
};

export default SelectJobForInterviewModal;
